// Какие экраны палитра показывает этому человеку.
//
// Строка палитры ведёт в раздел, а раздел открывается по СВОЕМУ праву. Прежняя проверка смотрела
// только на право строки: у «На что потрачено» это право на отчёты, и его есть у операционного
// руководства, кадров, табельщика и рекрутёра. А раздел «Суточные расходы» открывается по праву
// на подотчёт, которого у них нет вовсе (подотчёт им скрыт целиком). Они находили строку,
// нажимали Enter и попадали на «Раздел не входит в ваши права»: тупик там, где палитра
// обязана быть короче мыши.
//
// Теперь строка показывается, только если человеку виден её раздел в полосе разделов И есть
// право самой строки. Полоса и палитра обязаны согласоваться: то, чего нет в полосе, не
// находится и по Ctrl+K.

import { canAny, visibleSections } from '@/shared/rbac/permissions';

import { АДРЕСА, type Адрес } from './адреса';

export function доступныеАдреса(права: readonly string[]): readonly Адрес[] {
  const разделы = new Set<string>(visibleSections(права).map((раздел) => раздел.slug));
  return АДРЕСА.filter((адрес) => разделы.has(адрес.раздел) && canAny(права, адрес.права));
}
